import script from "./Yo.vue?vue&type=script&setup=true&lang=js"
export * from "./Yo.vue?vue&type=script&setup=true&lang=js"

import "./Yo.vue?vue&type=style&index=0&id=1ebdc4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebdc4d8"]])

export default __exports__